import { render } from "./EnterBaihai.vue?vue&type=template&id=4789b408&scoped=true&ts=true"
import script from "./EnterBaihai.vue?vue&type=script&lang=ts"
export * from "./EnterBaihai.vue?vue&type=script&lang=ts"

import "./EnterBaihai.vue?vue&type=style&index=0&id=4789b408&lang=less&scoped=true"

import exportComponent from "/Users/jiangshanwen/workspace/website-3.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4789b408"]])

export default __exports__